import { FormSection } from '@/api/rest/connectionApplication/useGetConnectionApplicationSchema';
import { ValidationMessages } from '@payaca/ambrosia';

import { FC } from 'react';
import { get, useFieldArray, useFormContext } from 'react-hook-form';
import FieldSet from './FieldSet';
import FieldSetArrayInnerCard from './FieldSetArrayInnerCard';
import FieldSetArrayOuterCard from './FieldSetArrayOuterCard';
import { fieldValidationState } from './utils/reactHookForm';

const FieldSetArray: FC<{
  schemaSection: FormSection;
  definitions: Record<string, any>;
  fieldKey: string;
}> = ({ definitions, schemaSection, fieldKey: key }) => {
  const form = useFormContext();
  const fieldArrayError = get(form?.formState?.errors, key);

  const fieldArray = useFieldArray({ control: form?.control, name: key });

  return (
    <FieldSetArrayOuterCard
      onAdd={
        // conditionally allow add dependent on a maxItems limit
        schemaSection.maxItems &&
        fieldArray.fields.length >= schemaSection.maxItems
          ? undefined
          : () => fieldArray.append({})
      }
    >
      {fieldArray.fields.map((field: any, index: number) => {
        // namespace for field array index
        const namespace = `${key}.${index}`;

        return (
          <FieldSetArrayInnerCard
            key={field.id}
            onRemove={
              // conditionally allow remove dependent on a minItems limit
              schemaSection.minItems &&
              fieldArray.fields.length <= schemaSection.minItems
                ? undefined
                : () => fieldArray.remove(index)
            }
          >
            {schemaSection.items.type === 'object' && (
              <FieldSet
                namespace={namespace}
                formSection={schemaSection.items}
                definitions={definitions}
              />
            )}
          </FieldSetArrayInnerCard>
        );
      })}

      {!!fieldArrayError?.message && (
        <ValidationMessages
          validationState={fieldValidationState(fieldArrayError)}
        />
      )}
    </FieldSetArrayOuterCard>
  );
};

export default FieldSetArray;
